import React from "react";
import moment from "moment";
import { Cell, Column } from "react-table";

import { DataTable, fuzzyTextFilter, Link } from "@components";
import { useOrg } from "@hooks";
import { Feature } from "@utils";

import { PolicyCell } from "@pages/projects/components/PolicyCell";
import { TagCell } from "@pages/projects/components/TagCell";
import { Repo } from "@pages/projects/types";

const PAGINATION_SETTINGS = { pageSize: 10 };

const COLUMNS: Column<Repo>[] = [
  {
    Header: "Project",
    id: "name",
    accessor: "name",
    Cell: ({ row }) => (
      // No link here because there is no project page for the demo repo
      <Link to="findings">{row.original.name}</Link>
    ),
  },
  {
    Header: "Policies",
    id: "policies",
    accessor: (repo) => repo.policies.map((r) => r.name).join(","),
    Cell: () => <PolicyCell selectedPolicies={[]} />,
  },
  {
    Header: "Last scan",
    id: "last_scanned",
    accessor: (repo) =>
      repo.latest_scan_at && new Date(repo.latest_scan_at).valueOf(),
    Cell: ({ row }: Cell<Repo>) => (
      <div>{moment(row.original.latest_scan_at).fromNow()}</div>
    ),
  },
];

interface Props {
  demoRepo: Repo;
}

export const DemoProjectTable: React.FC<Props> = ({ demoRepo }) => {
  const org = useOrg();
  const isNolicy = Feature.isNolicy({ org });

  if (org && !COLUMNS.find((c) => c.id === "tags")) {
    COLUMNS.push({
      Header: "Tags",
      id: "tags",
      accessor: (repo) => repo.tags?.join(","),
      Cell: ({ row }: Cell<Repo>) => <TagCell tags={row.original.tags || []} />,
    });
  }

  // We don't want to show the policies column for those orgs that are on the rule board
  // We filter here to just keep the order in place for everything else
  return (
    <div className="panel">
      <DataTable
        columns={
          isNolicy
            ? COLUMNS.filter((column) => column.id !== "policies")
            : COLUMNS
        }
        data={[demoRepo]}
        pagination={PAGINATION_SETTINGS}
        filter={fuzzyTextFilter}
        sorting
      />
    </div>
  );
};
